import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';
import { FaRegTrashAlt } from "react-icons/fa";
import { RiAddBoxLine } from "react-icons/ri";
import PlanCrudService from '../../services/PlanCrudService';
import InputText from '../../components/Forms/InputText';
import ModulesTab from './ModulesTab';


export default function ModalPlan({ show, handleClose, dataItem, setRenderRows }) {

  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;

  const newGroupFeature = useRef(null);
  const refArray = useRef([]);

  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [hasFreeTrial, setFreeTrial] = useState(false);
  const [comission, setComission] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [description, setDescription] = useState('');

  const [limits, setLimits] = useState({});
  const [features, setFeatures] = useState([]);
  const [suscriptions, setSuscriptions] = useState([]);
  const [t1Pagos, setT1Pagos] = useState([]);

  const [newFrequency, setNewFrequency] = useState('');
  const [newPeriod, setNewPeriod] = useState('');

  const [successSend, setSuccessend] = useState(null);
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);

  const [modules, setModules] = useState([]);
  const [editedModules, setEditedModules] = useState([]);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {

      PlanCrudService.getPlanById(dataItem.codeItem).then(async res => {

        let currentPlan = res.data.data[0];

        setName(currentPlan.name);
        setPrice(currentPlan.price);
        setCategory(currentPlan.category);
        setFreeTrial(currentPlan.hasFreeTrial);
        setComission(currentPlan.comission);
        setEnabled(currentPlan.enabled);
        setDescription(currentPlan.description);
        setLimits(currentPlan.limits);
        setFeatures(currentPlan.features);
        setModules(currentPlan.modules);
        setSuscriptions(currentPlan.suscriptions);
        setT1Pagos(currentPlan.t1Pagos);

      });
    } else {

      setName('');
      setPrice('');
      setCategory('');
      setFreeTrial(false);
      setComission('');
      setEnabled(false);
      setDescription('');
      setLimits({});
      setFeatures([]);
      setModules([]);
      setSuscriptions([]);
      setT1Pagos([]);
      setNewFrequency('');
      setNewPeriod('');

      setEnableSaveChanges(true);
      setSuccessend(null);

    }
  }, [dataItem, show]);

  const updateSuscription = (event, index) => {
    const newSuscriptions = [...suscriptions];
    const newT1Pagos = [...t1Pagos];
    switch (event.target.name) {
      case 'Price': newSuscriptions[index]['price'] = parseInt(event.target.value); break;
      case 'PeriodType': newSuscriptions[index]['periodType'] = event.target.value; break;
      case 'Frequency': newSuscriptions[index]['frequency'] = parseInt(event.target.value); break;
      case 'Idt1Pagos': newT1Pagos[index]['id'] = event.target.value; break;
      default: break;
    }
    setT1Pagos(newT1Pagos);
    setSuscriptions(newSuscriptions);
    setEnableSaveChanges(false);
  }

  const formFieldsHandler = (event) => {
    switch (event.target.name) {
      case 'Name': setName(event.target.value); break;
      case 'Price': setPrice(parseInt(event.target.value)); break;
      case 'Category': setCategory(event.target.value); break;
      case 'FreeTrial': setFreeTrial(event.target.value); break;
      case 'Comission': setComission(parseFloat(event.target.value)); break;
      case 'Enabled': setEnabled(event.target.value); break;
      case 'Description': setDescription(event.target.value); break;
      case 'Products': setLimits({ ...limits, ['products']: parseInt(event.target.value) }); break;
      case 'Branches': setLimits({ ...limits, ['branches']: parseInt(event.target.value) }); break;
      case 'Users': setLimits({ ...limits, ['users']: parseInt(event.target.value) }); break;
      case 'NewFrequency': setNewFrequency(parseInt(event.target.value)); break;
      case 'NewPeriod': setNewPeriod(event.target.value); break;
      default: break;
    }
    setEnableSaveChanges(false);
  }

  const setAddNewFeature = (index) => {
    if (refArray.current[index].value) {
      let newFeature = refArray.current[index].value;
      const newFeatures = [...features];
      newFeatures[index].featureList.push(newFeature);
      setFeatures(newFeatures);
      setEnableSaveChanges(false);
      refArray.current[index].value = '';
    }
  }

  const DeleteFeature = (index, featureIndex) => {
    const updatedFeatures = [...features];
    updatedFeatures[index].featureList.splice(featureIndex, 1);
    setFeatures(updatedFeatures);
    setEnableSaveChanges(false);
  };

  const setAddNewSuscriptions = () => {
    let newFeature = { price: 0, frequency: newFrequency, periodType: newPeriod };
    setSuscriptions(suscriptions => [...suscriptions, newFeature]);

    let newT1Pagos = { id: '' };
    setT1Pagos(t1Pagos => [...t1Pagos, newT1Pagos]);

    setEnableSaveChanges(false);
  }

  const setNewGroupFeature = () => {
    if (newGroupFeature.current.value) {
      let newFeature = { featureList: [], description: '', name: newGroupFeature.current.value };
      setFeatures(features => [...features, newFeature]);
      setEnableSaveChanges(false);
      newGroupFeature.current.value = '';
    }
  }

  const DeleteSuscriptions = (indexItem) => {
    setSuscriptions((prevState) =>
      prevState.filter((todo, index) => index !== indexItem)
    );
    setT1Pagos((prevState) =>
      prevState.filter((todo, index) => index !== indexItem)
    );
    setEnableSaveChanges(false);
  };

  const handleSubmit = async () => {
    try {
      let updatePlan = { name, price, category, hasFreeTrial, comission, enabled, description, limits, features, modules, suscriptions, t1Pagos };
      if (!dataItem.codeItem && dataItem.typeView === 'Create') {
        PlanCrudService.createPlan(updatePlan).then(res => {
          sleep(1500).then(() => {
            handleClose();
            window.location.href = '/plans';
          });
        });
      } else {
        await PlanCrudService.updatePlan(updatePlan, dataItem.codeItem);
        setSuccessend('success');
        await sleep(1500);
        handleClose();
        window.location.href = '/plans';
      }
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status !== 200) {
        setSuccessend('danger');
      }
    }
  };

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time))
  }

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (<><Button type="button" disabled={enableSaveChanges} onClick={() => handleSubmit()} >Guardar Cambios</Button></>);
  }
  if (dataItem.typeView === 'Delete') {
    addSubmitButton = (<><Button type="button" variant="danger" onClick={() => handleDelete()} >Si Eliminar</Button></>);
  }

  const setCloseButton = (<><Button variant="secondary" onClick={handleClose}> Close </Button></>);

  return (<>
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem} </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(dataItem.typeView === 'Delete') ? (<Alert key='danger' variant='danger'> ¿Seguro que quieres Eliminar el Plan? </Alert>) : ""}

        <Tabs defaultActiveKey="main" id="justify-tab-example" className="mb-3" justify>

          <Tab eventKey="main" title="Data Plan">
            <Row className="mb-3">
              <InputText defaultValue={description} label={'Description'} handler={formFieldsHandler} conditionView={conditionView} width={'10'} />
              <InputText defaultValue={category} label={'Category'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
            </Row>
            <Row className="mb-3">
              <InputText defaultValue={name} label={'Name'} handler={formFieldsHandler} conditionView={conditionView} width={'3'} />
              <InputText defaultValue={price} label={'Price'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />

              <Form.Group as={Col} md="2" key={10}>
                  <Form.Label>FreeTrial</Form.Label>
                  <Form.Select
                    name="FreeTrial"
                    onChange={conditionView ? null : formFieldsHandler}
                    readOnly={conditionView ? true : false}
                    disabled={conditionView ? true : false}
                    value={hasFreeTrial}
                  >
                    <option key='false' value='false' >False</option>
                    <option key='true' value='true' >True</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group as={Col} md="2" key={11}>
                  <Form.Label>Enabled</Form.Label>
                  <Form.Select
                    name="Enabled"
                    onChange={conditionView ? null : formFieldsHandler}
                    readOnly={conditionView ? true : false}
                    disabled={conditionView ? true : false}
                    value={enabled}
                  >
                    <option key='false' value='false' >False</option>
                    <option key='true' value='true' >True</option>
                  </Form.Select>
                </Form.Group>

              <InputText defaultValue={comission} label={'Comission'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
            </Row>

            <hr></hr>
            <Row className="mb-3">
              <Form.Group as={Col} md="2" key={'limits'}>
                <Form.Label>Limits : </Form.Label>
              </Form.Group>

              <InputText defaultValue={limits.products} label={'Products'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
              <InputText defaultValue={limits.branches} label={'Branches'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
              <InputText defaultValue={limits.users} label={'Users'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
            </Row>

          </Tab>

          <Tab eventKey="suscriptions" title="Suscriptions">

            <Accordion>
              {suscriptions.map((suscription, index) => {
                let valueIdT1Pagos = (t1Pagos?.length === 0) ? '' : t1Pagos[index].id;
                return (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header> {suscription.frequency} {suscription.periodType} </Accordion.Header>
                    <Accordion.Body>
                      <Row className="mb-3">
                        <InputText defaultValue={suscription.price} label={'Price'} handler={(e) => updateSuscription(e, index)} conditionView={conditionView} width={'5'} />
                        <InputText defaultValue={suscription.periodType} label={'PeriodType'} handler={(e) => updateSuscription(e, index)} conditionView={conditionView} width={'2'} />
                        <InputText defaultValue={suscription.frequency} label={'Frequency'} handler={(e) => updateSuscription(e, index)} conditionView={conditionView} width={'2'} />
                      </Row>
                      <Row className="mb-3">
                        <InputText defaultValue={valueIdT1Pagos} label={'Idt1Pagos'} handler={(e) => updateSuscription(e, index)} conditionView={conditionView} width={'7'} />
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })}
            </Accordion>

            <hr></hr>
            <Row className="mb-3">

              {!conditionView ? (<>
                <Form.Group as={Col} md="3" key={'newPeriod'}>
                  <Form.Select name={'NewPeriod'} onChange={formFieldsHandler}>
                    <option >Add New Period</option>
                    <option value="month">month</option>
                    <option value="year">year</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col} md="2" key={'NewFrequency'}>
                  <Form.Select name={'NewFrequency'} onChange={formFieldsHandler}>
                    <option >Frequency</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="3">4</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group as={Col} md="4" key={'addNewSuscriptions'}>
                  <Button type="button" onClick={() => setAddNewSuscriptions()} > <RiAddBoxLine /> </Button>
                </Form.Group></>) : ('')}
            </Row>

          </Tab>

          <Tab eventKey="features" title="Features">

            <Accordion>

              {features.map((itemRole, index) => {
                return (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>Name : {itemRole.name} </Accordion.Header>
                    <Accordion.Body>
                      <Row className="mb-3">
                        {itemRole.featureList.map((feature, indexItem) => {
                          return ((<Form.Group as={Col} md="12" key={indexItem}>
                            <Form.Label> <FaRegTrashAlt type='button' alt='Eliminar' onClick={() => DeleteFeature(index, indexItem)} /> - {feature}</Form.Label>
                          </Form.Group>))
                        })}
                      </Row>
                      <Row className="mb-3">

                        {!conditionView ? (<>
                          <Form.Group as={Col} md="6" key={1}>
                            <Form.Control ref={ref => {
                              refArray.current[index] = ref;
                            }} type="text" placeholder="New Feature" />
                          </Form.Group>

                          <Form.Group as={Col} md="4" key={2}>
                            <Button type="button" onClick={() => setAddNewFeature(index)} > <RiAddBoxLine /> </Button>
                          </Form.Group></>) : ('')}
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })}
            </Accordion>

            <hr></hr>
            <Row className="mb-3">
              {!conditionView ? (<>
                <Form.Group as={Col} md="6" controlId="controlId8">
                  <Form.Control ref={newGroupFeature} type="text" placeholder="New Group of features." />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="controlId9">
                  <Button type="button" onClick={() => setNewGroupFeature()} > <RiAddBoxLine /> </Button>
                </Form.Group></>) : ('')}
            </Row>
          </Tab>

          <Tab eventKey="modules" title="Modules">
            <ModulesTab
              modules={modules}
              editedModules={editedModules}
              setModules={setModules}
              setEditedModules={setEditedModules}
              conditionView={conditionView}
              setEnableSaveChanges={setEnableSaveChanges}
            />
          </Tab>
        </Tabs>

        <hr></hr>
        {addSubmitButton}
        {'  '}  {'  '}
        {setCloseButton}

        {(successSend == 'danger') ? (<Alert key='danger' variant='danger'> ¡Plan no actualizado!</Alert>)
          : (successSend == 'success') ? (<Alert key='success' variant='success'> ¡Plan Actualizado!</Alert>) : ""}
      </Modal.Body>
    </Modal>
  </>)
}